import { z } from "zod";

// ============================================================================
// BASE CALL ANALYSIS SCHEMA (matches backend DbCallAnalysisOutput)
// ============================================================================

// To sync with DbCallAnalysisOutput in backend/schemas/call-analysis.ts
// This matches the call_analysis_view which extracts fields from JSONB data
const BaseCallAnalysisSchema = z.object({
  // Primary fields
  id: z.string(),

  // Relations
  callAttemptId: z.string(),

  // Status
  status: z.string(), // 'pending' | 'processing' | 'completed' | 'failed'

  // Timestamps
  createdAt: z.string(),
  updatedAt: z.string(),

  // Analysis results (extracted from data JSONB in the view)
  sentimentScore: z.number().nullable().optional(),
  keyPoints: z.unknown().nullable().optional(), // Array of key points
  concerns: z.unknown().nullable().optional(), // Array of concerns
  followUpRecommendations: z.unknown().nullable().optional(), // Array of recommendations
  qualityScore: z.number().nullable().optional(),
  analysisMetadata: z.unknown().nullable().optional(),
  errorMessage: z.string().nullable().optional(),
  completedAt: z.string().nullable().optional(),
});

export const CallAnalysisSchema = BaseCallAnalysisSchema;

export const CallAnalysisListItemSchema = BaseCallAnalysisSchema;

export const CallAnalysisListSchema = z.array(CallAnalysisListItemSchema);

// ============================================================================
// TYPE EXPORTS
// ============================================================================

export type CallAnalysis = z.infer<typeof CallAnalysisSchema>;
export type CallAnalysisListItem = z.infer<typeof CallAnalysisListItemSchema>;
